module.exports = __webpack_public_path__ + "static/img/10.90d113d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/10.png
// module id = qtNl
// module chunks = 0